// @flow

import React from 'react';
import bemify from 'bemify-js';

const bem = bemify('popover-arrow');

// Given a width and height (`w` and `h`), returns an object
// representing the width and height of the arrow as well as
// the drawing instructions (`d`). Note that the arg _names_
// are intentionally flipped for vertical vs horizontal.
const arrows = {
  up: (w, h) => ({ w, h, d: `M 0,${h} L ${w / 2},0 ${w},${h} Z` }),
  down: (w, h) => ({ w, h, d: `M 0,0 L ${w / 2},${h} ${w},0 Z` }),
  right: (h, w) => ({ w, h, d: `M 0,0 L ${w},${h / 2} 0,${h} Z` }),
  left: (h, w) => ({ w, h, d: `M ${w},0 L 0,${h / 2} ${w},${h} Z` }),
};

type PopOverArrowProps = {
  direction?: 'up' | 'down' | 'right' | 'left',
  longLen: number,
  shortLen: number,
  className?: string,
};

const PopoverArrow = ({
  direction,
  longLen,
  shortLen,
  className,
}: PopOverArrowProps) => {
  // $FlowFixMe
  const { w, h, d } = arrows[direction](longLen, shortLen);

  return (
    <svg className={bem(className)} height={h} width={w}>
      <path d={d} />
    </svg>
  );
};

PopoverArrow.defaultProps = {
  longLen: 20,
  shortLen: 10,
};

export default PopoverArrow;
